@if (workflow$ | async; as workflow) {
    @if (href$ | async; as href) {
        <a [routerLink]="href.path"
           [queryParams]="href.queryParams"
           [attr.data-tour]="'pathway-title-' + workflow.workflowId">{{ workflow.name }}</a>
    }
}
